import { useNavigate } from "react-router";
import { toast } from "sonner";

import { MainProgram, MiniProgram, ProgramDialog } from "@/types/programs";

import { AddProgramsDialog } from "./AddProgramDialog";
import { ArchiveProgramDialog } from "./ArchiveProgramDialog";
import { EndProgramDialog } from "./EndProgramDialog";
import { UpdateProgramsDialog } from "./UpdateProgramDialog";

interface ModifyProgramDialogsProps {
  dialogOpen?: ProgramDialog;
  selectedProgram?: MainProgram | MiniProgram;
  onClosedDialog: () => void;
  onProgramArchived?: () => void;
  refetch: (variables?: ExplicitAny) => void;
}

export function ModifyProgramDialogs({
  dialogOpen,
  selectedProgram,
  refetch,
  onClosedDialog,
  onProgramArchived,
}: ModifyProgramDialogsProps) {
  const navigate = useNavigate();

  return (
    <div>
      <AddProgramsDialog
        open={dialogOpen === "add-programs" || dialogOpen === "clone-program"}
        afterAddedProgram={(program) => {
          refetch();
          onClosedDialog();
          if (program) {
            navigate(`/programs/${program.id}`);
          }
        }}
        onClose={() => {
          onClosedDialog();
        }}
        mode={dialogOpen === "add-programs" ? "create" : "clone"}
        selectedProgram={selectedProgram}
      />
      {selectedProgram && (
        <>
          <UpdateProgramsDialog
            open={dialogOpen === "update-program"}
            afterUpdateProgram={() => {
              refetch();
              onClosedDialog();
            }}
            onClose={() => {
              onClosedDialog();
            }}
            program={selectedProgram}
          />
          <ArchiveProgramDialog
            open={dialogOpen === "archive-program"}
            afterArchivedProgram={() => {
              refetch();
              toast.success("Program archived.");
              onClosedDialog();
              onProgramArchived && onProgramArchived();
            }}
            onClose={() => {
              onClosedDialog();
            }}
            program={selectedProgram}
          />
          <EndProgramDialog
            open={dialogOpen === "end-program"}
            afterEndProgram={() => {
              refetch();
              toast.success("Program marked as complete");
              onClosedDialog();
            }}
            onClose={() => {
              onClosedDialog();
            }}
            program={selectedProgram}
          />
        </>
      )}
    </div>
  );
}
